import React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';
import { Grid, units } from '@ha/dsl';

const styles = createStyles({
  fullHeight: {
    minHeight: units.vh(100),
  },
  grow: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
});

const StickyFooterInternal: React.FC<WithStyles<typeof styles>> = ({
  children,
  classes,
}) => (
  <Grid
    className={classes.fullHeight}
    direction="column"
    wrap="nowrap"
    container
  >
    <div className={classes.grow}>{children}</div>
  </Grid>
);

const StickyFooter = withStyles(styles)(StickyFooterInternal);
export { StickyFooter };
